<template>
	<div class="login-box">
		<!--  顶部tab  -->

		<!--  操作box  -->
		<div class="input-box">
			<div class="login-title">
				扫码登录
			</div>
			<div class="qr">
				<img :src="qr" />
			</div>
			<div style="color:#999999;font-size:14px;margin-top:10px;">
				微信扫一扫快捷登录
			</div>
			<!--  公告  -->
			<div class="g-p-l-20 g-p-r-20 g-p-b-20">
				<notice-bar></notice-bar>
			</div>
		</div>
	</div>
</template>

<script>
	import md5 from 'js-md5'
	import {
		login,
		userInfo,
		register,
		getLoginQr,
		checkLogin
	} from "@/api/user.js"
	import {
		resumelDetail
	} from "@/api/job.js"
	import {
		HumpObj
	} from "@/utils/common.js"
	import sendCode from "@/mixins/sendCode";
	import NoticeBar from "@/views/home/components/notice-bar";
	export default {
		name: "login-card",
		components: {
			NoticeBar
		},
		mixins: [sendCode],
		data() {
			return {
				qr: '',
				qrsence: '',
				active: 1,
				tabIndex: '1',
				phone: '',
				psw: '',
				textCode: '',
				logining: false,
				timer: null,

			}
		},
		created() {
			this.getLoginQr()

		},
		beforeDestroy() {
			clearInterval(this.timer);
			this.timer = null;
		},
		methods: {
			getLoginQr() {
				getLoginQr().then(res => {
					console.log(res)
					this.qr = res.image
					this.qrsence = res.key
					// this.timer = setInterval(() => {
					// 	setTimeout(this.checkLogin, 0);
					// }, 1000);
					this.checkLogin()
				})
			},
			checkLogin() {
				checkLogin({
					scene:this.qrsence
				}).then(res=>{
					if(res.code==0){
						this.timer=setTimeout(()=>{
							this.checkLogin()
						},2000)
					}else{
						if(res.code==200){
							this.$store.commit('$uStore', {
								name: 'isLogin',
								value: true
							})
							this.$store.commit('$uStore', {
								name: 'accessToken',
								value: res.data.access_token
							})
							localStorage.setItem('accessToken', res.data.access_token);
							this.$store.commit('$uStore', {
								name: 'refreshToken',
								value: res.data.access_token
							})
							this.$store.commit('$uStore', {
								name: 'userInfo',
								value: res.data
							})
							this.getMyResume();
							this.getUserInfo();
						}
						
					}
				})
			},
			
			getUserInfo() {
				userInfo({}).then(res => {
					let storeUserInfo = this.$store.state.userInfo;
					Object.assign(res, storeUserInfo);
					this.$store.commit('$uStore', {
						name: 'userInfo',
						value: res
					});
				})
			},
			getMyResume() {
				resumelDetail({}).then(res => {
					this.$store.commit('$uStore', {
						name: 'userInfo.resumeId',
						value: res.id
					})
				})
			}
			
		},

	}
</script>

<style lang="scss" scoped>
	.input-img {
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}

	.tab-bar {
		height: 38px;
		width: 245px;
		background: #e8eefc;
		border-radius: 10px;

		.tab-item {
			cursor: pointer;
			width: 51.5%;
			height: 38px;
			line-height: 38px;
			display: block;
			z-index: 0;
			bottom: 0;
			color: #407aff;
			font-size: 14px;

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				z-index: -1;
				background: #e8eefc;
			}
		}

		.left-bar {
			transform-origin: bottom left;
			left: 0;

			&::before {
				transform-origin: bottom left;
				border-top-right-radius: 10px;
				border-top-left-radius: 10px;
				transform: perspective(10px) rotateX(1deg);
			}
		}

		.right-bar {
			transform-origin: bottom right;
			right: 0;

			&::before {
				transform-origin: bottom right;
				border-top-left-radius: 10px;
				border-top-right-radius: 10px;
				transform: perspective(10px) rotateX(1deg);
			}
		}

		.active-tab {
			z-index: 99;
			filter: drop-shadow(0 0 15px rgba(0, 0, 0, 0.05));
			color: #000 !important;
			font-weight: bold !important;
			transition: all 0.2s linear;
			height: 50px;
			line-height: 50px;
			font-size: 18px;

			&::before {
				content: '';
				background: #fff !important;
				transition: all 0.2s linear;
			}
		}
	}

	.input-box {
		width: 250px;
		background: #fff;
		border-radius: 10px;
		text-align: center;

		.total-padding {
			padding: 0 15px 10px;
		}

		.qr {
			height: 200px;
			padding: 0 25px;
			text-align: center;
		}

		.qr img {
			width: 100%;
			height: auto;
		}

		.login-title {
			padding: 10px;
			font-weight: bold;
			font-size: 18px;
		}

		::v-deep .el-tabs__nav-wrap::after {
			background: none;
		}

		.input-row {
			background: #f6f6f8;
			border-radius: 5px;
			padding: 0 9px;
		}
	}

	::v-deep .el-input__inner {
		border: none;
		outline: none;
		background-color: #f6f6f8;
		padding: 0 7px;
	}

	::v-deep .el-tabs__item {
		font-size: 12px;
	}

	.submit-btn {
		padding: 7px 0;
		font-size: 14px;
		width: 100%;
		margin: 10px 0;
	}

	.text-code-btn {
		padding: 0 5px;
		margin: 0 0 0 5px;
		width: 50%;
		white-space: nowrap;
		font-size: 12px;
	}
</style>
